import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgProgressModule } from '@ngx-progressbar/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfirmComponent } from './common/confirm/confirm.component';
import { DialogComponent } from './common/dialog/dialog.component';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { ProgressInterceptor } from './interceptors/progress.interceptor';
import { JeMaterialModule } from './je-material/je-material.module';
import { AccountComponent } from './pages/account/account.component';
import { AccountComponent as AdminAccountComponent } from './pages/admin/account/account.component';
import { AccountsComponent } from './pages/admin/accounts/accounts.component';
import { LicenceTypesComponent } from './pages/admin/licence-types/licence-types.component';
import { LicenceComponent } from './pages/admin/licence/licence.component';
import { InformationComponent } from './pages/dialogs/information/information.component';
import { LoginComponent } from './pages/login/login.component';
import { AdminFrameComponent } from './frame/admin-frame/admin-frame.component';
// import { WhoAreYouComponent } from './pages/who-are-you/who-are-you.component';

@NgModule({
  declarations: [
    AppComponent,
    AccountComponent,
    InformationComponent,
    // WhoAreYouComponent,
    LoginComponent,
    AdminAccountComponent,
    AccountsComponent,
    LicenceComponent,
    ConfirmComponent,
    DialogComponent,
    LicenceTypesComponent,
    AdminFrameComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    JeMaterialModule,
    NgProgressModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ProgressInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
